module.exports = __webpack_public_path__ + "img/人.8bd6204f.png";